import {VueExtension} from '../../utils/extensions/vue'
import Steps from './steps.jsx'
import './steps.scss'

VueExtension.WithInstall(Steps)

export default Steps